
import { hideLoading, showLoading } from "../../../loading";
import request from "../../../request";
import swal from 'sweetalert';
import ResponsiveTable from "../../../components/ResponsiveTable";
import { connect } from "react-redux";
import DateTime from "../../../components/DateTime";
import StyledLink from "../../../components/StyledLink";
import links from "../../../links";
import AttachmentList from "../../../components/AttachmentList";
import NavigationStateSaver from "../../../components/NavigationStateSaver";
import { formatMoney } from "../../../../../shared/utils";


class _LoanPayments extends NavigationStateSaver {

   state = {
      payments: null,
      page: 0,
      limit: 10,
      total: 0,
      filters: {
         coming_up: undefined,
         paid: undefined,
         from: undefined,
         to: undefined,
      }
   }

   fetchLoanPayments = async () => {

      try {

         showLoading();

         const params = {
            page: this.state.page + 1,
            limit: this.state.limit
         }

         const { coming_up, paid, from, to } = this.state.filters;
         if (typeof coming_up === 'boolean') params.coming_up = coming_up;
         if (typeof paid === 'boolean') params.paid = paid;
         if (from) params.from = from;
         if (to) params.to = to;

         const res = await request.get('/api/general/loan-payments', { params });
         const { payments, total } = res.data;

         this.setState({ payments, total });

      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }

   }

   async componentDidMount() {
      await super.componentDidMount();
      if (!this.state.payments)
         await this.fetchLoanPayments();
   }

   render() {

      return <>
         <ResponsiveTable
            cols={[
               {
                  field: 'loan',
                  caption: 'Loan',
                  render: loan => loan ? <StyledLink to={links.loan(loan._id)}>{loan.loan_no}</StyledLink> : '–'
               },
               {
                  field: 'customer',
                  caption: 'Customer',
                  render: (_, loan) => {
                     if (loan.customer) {
                        return <StyledLink to={links.customer(loan.customer._id)}>
                           {loan.customer.name} {loan.customer.surname}
                        </StyledLink>
                     } else {
                        return '–'
                     }
                  }
               },
               {
                  field: 'amount',
                  caption: 'Amount',
                  render: amount => formatMoney(amount),
               },
               {
                  field: 'due_at',
                  caption: 'Due Date',
                  render: date => <DateTime value={date} dateOnly />
               },
               {
                  field: 'paid',
                  caption: 'Paid',
                  render: paid => paid ? <span className="text-green-600">YES</span> : <span className="text-red-500">NO</span>
               },
               {
                  field: 'paid_at',
                  caption: 'Date Paid',
                  render: date => date ? <DateTime value={date} /> : '–'
               },
               {
                  field: 'attachments',
                  caption: 'Attachments',
                  render: attachments => {
                     if (attachments?.length) {
                        return <AttachmentList
                           attachments={attachments}
                           className="max-w-40"
                        />
                     }

                     return '–'
                  }
               }
            ]}
            rows={this.state.payments}
            fullHeight
            onRefresh={this.fetchLoanPayments}
            pagination={{
               page: this.state.page,
               count: this.state.total,
               rowsPerPage: this.state.limit,
               labelRowsPerPage: 'Payments per page',
               onPageChange: (_, page) => this.setState({ page }, this.fetchLoanPayments),
               onRowsPerPageChange: e => this.setState({ limit: e.target.value }, this.fetchLoanPayments)
            }}
            filters={{
               onChange: filters => this.setState({ filters, page: 0 }, this.fetchLoanPayments),
               filters: [
                  {
                     field: 'coming_up',
                     label: 'Due date coming up',
                     type: 'boolean',
                     value: this.state.filters.coming_up
                  },
                  {
                     field: 'paid',
                     label: 'Paid',
                     type: 'boolean',
                     value: this.state.filters.paid
                  },
                  {
                     field: 'from',
                     label: 'From',
                     type: 'date',
                     value: this.state.filters.from,
                     shouldDisplay: filters => typeof filters.coming_up !== 'boolean',
                  },
                  {
                     field: 'to',
                     label: 'To',
                     type: 'date',
                     value: this.state.filters.to,
                     shouldDisplay: filters => typeof filters.coming_up !== 'boolean',
                  }
               ]
            }}
         />
      </>
   }
}


const mapStateToProps = state => ({ roles: state.user?.roles || [] });
const LoanPayments = connect(mapStateToProps)(_LoanPayments);

export default LoanPayments;